module.exports = __webpack_public_path__ + "static/media/icon-barcode.78061d8f.svg";